import { find, findAll, register } from '../../../../Javascript/Sysmex/Utils'

const productDetail = el => {
  const filterForm = find('#filter-form', el)

  if (filterForm) {
    const filterItems = findAll('.filter-item', filterForm)
    const documentLanguageSelect = el.querySelector('input[name="documentLanguage"]')

    filterForm.addEventListener('submit', (e) => {
      const selectedLanguage = documentLanguageSelect.value

      filterItems.forEach(filterItem => {
        const isVisible = (selectedLanguage === '' || selectedLanguage === filterItem.dataset.filterValue)
        filterItem.style.display = isVisible ? '' : 'none'
      })

      e.preventDefault()
    })
  }
}

register('productDetail', productDetail)
